import { render, staticRenderFns } from "./EnergyBillDistReportDetails.vue?vue&type=template&id=f96f0c06"
import script from "./EnergyBillDistReportDetails.vue?vue&type=script&lang=js"
export * from "./EnergyBillDistReportDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports